// useResponsive.js
import { useTheme, useMediaQuery } from '@mui/material';

const useResponsive = () => {
  const theme = useTheme();
  
  // Detect if the screen is a mobile (smaller than 'sm' breakpoint)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return {
    isMobile,
  };
};

export default useResponsive;
